import React, {useEffect,  useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService"
import { useNavigate, NavLink, Navigate, UNSAFE_enhanceManualRouteObjects } from "react-router-dom";
import Botonera from "./Botonera";
import IndicadorCredito from "./IndicadorCredito";
import EPagosSites from "../EPagosSites";
import BotoneraWithFooter from "./BotoneraWithFooter";
import LogServices from "../../services/LogServices";
import { Spinner } from "reactstrap";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";



const BotoneraCredito = () => {
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [availableCredit, setAvailableCredit, setCredit] = useState("...");
    const [credito, setCredito] = useState({monto:""});
    const [botonCancela, setBotonCancela] = useState(false);

    
    const changeHandlerMonto = (e) => {
        const { name, value } = e.target;
        setCredito({
          ...credito,
          [name]: value,
        });}

        const hideBotoneraFooter = () => {
            document.getElementsByTagName("footer")[0].style.visibility='hidden';
            document.getElementById("miBotonera").style.visibility='hidden';
          }
    
          const showBotoneraFooter = () => {
            document.getElementsByTagName("footer")[0].style.visibility='visible';
            document.getElementById("miBotonera").style.visibility='visible';

          }

    const proceedCancelCharge = () => {
        EstacionamientoService.cancelaUltimaCargaEPagos(localStorage.getItem("estacionamiento_celular"),
        localStorage.getItem("estacionamiento_token"),localStorage.getItem("estacionamiento_pendiente_monto"),
        localStorage.getItem("estacionamiento_pendiente_transaccion"))
        .then((resp)=> {
            setErrorMessage("Operación pendiente eliminada");
            setBotonCancela(false);
            setLoading(false);
        })
        .catch((error)=>{
            console.log(error);
            LogServices.log("Error Cancelar operacion pendiente Estacionamiento ",localStorage.getItem("estacionamiento_celular"),error.message, error)
            setErrorMessage("No se pudo cancelar la operacion pendiente");
            setLoading(false);
        })
    }

    const cancelCharge = () => {
        EstacionamientoService.estadoUltimaCargaEPagos(localStorage.getItem("estacionamiento_celular"),
         localStorage.getItem("estacionamiento_token"))
         .then((resp)=>{
            if (resp.data.extra.estado == "PENDING") {
                localStorage.setItem("estacionamiento_pendiente_monto", resp.data.extra.monto);
                localStorage.setItem("estacionamiento_pendiente_transaccion", resp.data.extra.transactionId);
                proceedCancelCharge();

            }
            else setErrorMessage("La ultima carga no está en pendiente");

         })
         .catch((error)=>{
            console.log(error);
            LogServices.log("Error Consultar estado ultima carga ",localStorage.getItem("estacionamiento_celular"),error.message, error)
            setErrorMessage("Error al consultar el estado de la ultima carga");
            setLoading(false);
         })
         setLoading(true);
    }

    const continueCharge = () => {
        if (credito.monto==""){
            setErrorMessage("Se debe ingresar un monto valido");
            return;
        }
        EstacionamientoService.inicioCargaCredito(
            localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_token"),
            credito.monto
        )
        .then((resp)=>{
            if (resp.data.errorCode=="916"){
                localStorage.setItem("estacionamiento_carga_monto", credito.monto);
                localStorage.setItem("estacionamiento_carga_hash", resp.data.extra.token);
                localStorage.setItem("estacionamiento_carga_operacion", resp.data.extra.idOperacion);
                navigate("/estpagos");
                setLoaded(true);
            } else {
                if (resp.data.errorCode=="917")
                    setBotonCancela(true);
                    else
                    setBotonCancela(false);
                setErrorMessage(resp.data.messageError);
                setLoaded(true);
            }

        })
        .catch((error)=>{
            console.log(error);
            LogServices.log("Error Conectar estacionamiento Carga Credito ",localStorage.getItem("estacionamiento_celular"),error.message,error);
            setErrorMessage("Error de conectividad al servicio de carga de credito")
        });
        setLoaded(false);
    }

    

      useEffect(()=> {
        if (!loaded) {
            EstacionamientoService.login(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_pass"))            
            .then((resp) => { 
                setAvailableCredit(resp.data.saldoString);

            setLoaded(true);
        })
            .catch((error) => { setAvailableCredit("Error");
            console.log(error);
            LogServices.log("Error leyendo credito celular ",localStorage.getItem("estacionamiento_celular"),error.message,error);
        setErrorMessage("Error leyendo el credito")});}
      }, []);
    return (
        <>
        <section>
            <main>
       <div class="container text-center estacionamientoContent" >
       <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamiento")}}/>
       <EstacionamientoSmallHeader texto="Cr&eacute;dito" retorno="/estacionamiento"/>
     
       <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                    <button className="buttonSemiHighClip buttonGreyClip" > 
                        <img className="buttonCreditImage" src="./estacionamiento-pesos.png"/>
                        Cr&eacute;dito disponible <b>{availableCredit.replace(" ","")}</b></button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col captionText">
                    Ingrese un monto
                </div>
            </div>
            <div class="row">
                <div class="col">
                    
                    <input type="number" name="monto" 
                className="inputText inputTextMonto" value={credito.monto} onChange={changeHandlerMonto}
                min="50" onFocus={hideBotoneraFooter} onBlur={showBotoneraFooter}/>
                    </div>
        </div>
        <div class="row">
                <div class="col">
                    
                    <button class="buttonRegularClip"  onClick={continueCharge}>Cargar cr&eacute;dito</button>
                    </div>
        </div>
        </div>
        <p class="errorText" align="center">{errorMessage}</p>
        {botonCancela?<button class="buttonDanger" onClick={cancelCharge}>Cancelar carga pendiente</button>:""}
        {loading ?  <div align="center">
            <Spinner color="primary" align="center"/></div>:<></>}
        <Botonera/>    
        
       
        
        </main>
        </section>
        </>

    );
    }
export default BotoneraCredito;